import React, { Fragment, useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText
} from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function CreateBreakdownDialog({
  buttonLoading = null, setButtonLoading = null, po_doc_id,
  poName, addSnackbar, fetchPos = null, isIcon, fetchPoDetails = null
}) {
  const [open, setOpen] = useState(false);
  const [loadingBreakdown, setLoadingBreakdown] = useState(false);

  const fetchAction = fetchPos ? fetchPos : fetchPoDetails;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingBreakdown) {
      setOpen(false);
    }
  };

  const createBreakdown = async (po_doc_id) => {
    if (setButtonLoading) setButtonLoading(true);
    setLoadingBreakdown(true);
    try {
      let response = await sendRequest(`purchase-orders/create-breakdown?po_doc_id=${po_doc_id}`);
      fetchAction();
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      if (setButtonLoading) setButtonLoading(false);
      setLoadingBreakdown(false);
      handleClose();
    }
  }

  return (
    <Fragment>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Create Projections"}
        text={"Create Projections"}
        icon={CalculateIcon}
        disabled={!!buttonLoading}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingBreakdown}
      >
        <CustomDialogTitle
          header={"Create Product Projections"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>
            Are all products ready for projections?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingBreakdown}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingBreakdown}
            text={"Create Projections"}
            onClick={() => createBreakdown(po_doc_id)}
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}